import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig  = {
    apiKey: "AIzaSyAEWtJg21cSrA1a-gPh8_iABAQ06rguWYc",
    messagingSenderId: "459831623624",
    projectId: "e-baholash",
    authDomain: "e-baholash.firebaseapp.com",
    storageBucket: "e-baholash.appspod.com",
    databaseURL: "https://e-baholash.firebaseio.com",
    appId: "1:459831623624:web:78ecf22fb4d0a0a6"
};

const app = firebase.initializeApp(firebaseConfig);
const database = app.firestore();
export default database;